import { AxiosInstance } from 'axios';
import { result, Result } from 'util/result';
import Terra from '../Terra';
import { PandoraConfigResponse } from 'data/terra/api/terra/response/PandoraConfigResponse';
import { HestiaAppsResponse } from 'data/terra/api/terra/response/HestiaAppsResponse';

class FrontEndEndpoint {
  getPandoraConfigUrl = (clientId: string) =>
    `${Terra.TERRA_HOST}/${Terra.TERRA_BASE_API_URL}/pandora/${window.btoa(
      clientId
    )}`;

  getHestiaAppsUrl = (clientId: string) =>
    `${Terra.TERRA_HOST}/${Terra.TERRA_BASE_API_URL}/hestia/${window.btoa(
      clientId
    )}`;

  pandoraCache = (clientId: string) =>
    `${Terra.TERRA_HOST}/${
      Terra.TERRA_BASE_API_URL
    }/pandora/cache/${window.btoa(clientId)}`;
}


export class FrontEndApi {
  terraClient: AxiosInstance;
  endpoint = new FrontEndEndpoint();

  constructor(client: AxiosInstance) {
    this.terraClient = client;
  }

  fetchPandoraConfig(clientId: string): Promise<Result<PandoraConfigResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.get<PandoraConfigResponse>(
            this.endpoint.getPandoraConfigUrl(clientId)
          )
        ).data
    );
  }

  fetchHestiaApps(clientId: string): Promise<Result<HestiaAppsResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.get<HestiaAppsResponse>(
            this.endpoint.getHestiaAppsUrl(clientId)
          )
        ).data
    );
  }

  invalidatePandoraCache(clientId: string): Promise<Result<void>> {
    return result(
      async () =>
        await this.terraClient.delete(this.endpoint.pandoraCache(clientId))
    );
  }
}